// extracted by mini-css-extract-plugin
module.exports = {"Root":"sports-menu_Root__tG_TG","Title":"sports-menu_Title__UDxqe","Item":"sports-menu_Item__QNsCl","ItemActive":"sports-menu_ItemActive__TTEfp"};